document.addEventListener('DOMContentLoaded', function () {
  function iOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod',
      'MacIntel',
      'Macintosh',
      'MacOS',
      'Mac68K',
      'MacPPC',
      'Mac'
    ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }
  let if_IOS = iOS();
  if (if_IOS) {
    document.querySelector('#main').classList.add('ios-only');
  }
});